import { spawn, call, put, takeLatest } from 'redux-saga/effects';
import { createAction } from '@reduxjs/toolkit';
import { usersActions } from '../../../application/actions/users';

import api from '../../api/index';

const apiRequest = api(process.env.REACT_APP_HOST);


// GETALL
export function* getAllFetch() {
    yield put(usersActions.conexionGetAll({connection:true}));
    try {
        const url = `user`
        const response = yield call(
            apiRequest.get,
            url,
        );

        // Extraigo todos los datos
        const { data } = response;
        yield put(usersActions.getAll({data}));
    } catch (err) {
        yield put(usersActions.errorGetAll({error:true, message:err.message}));
    } finally {
        yield put(usersActions.conexionGetAll({connection:false}));
    }
}

// GETBYID
export function* getByIdFetch(e) {
    yield put(usersActions.conexionGetById({connection:true}));
    try {
        const  params  = e.payload;
        const url = `user/${params.id}`
        const response = yield call(
            apiRequest.get,
            url,
        );

        // Extraigo todos los datos
        const { data } = response;
        yield put(usersActions.getById({data}));
    } catch (err) {
        yield put(usersActions.errorGetById({error:true, message:err.message}));
    } finally {
        yield put(usersActions.conexionGetById({connection:false}));
    }
}

// CREATE
export function* createFetch(e) {
    yield put(usersActions.conexionCreate({connection:true}));
    try {
        const  params  = e.payload;
        const url = `user`
        const response = yield call(
            apiRequest.post,
            url,
            params
        );

        // Extraigo todos los datos
        const { result } = response;
        yield put(usersActions.create({result}));
    } catch (err) {
        yield put(usersActions.errorCreate({error:true, message:err.message}));
    } finally {
        yield put(usersActions.conexionCreate({connection:false}));
    }
}
// UPDATE
export function* updateFetch(e) {
    yield put(usersActions.conexionUpdate({connection:true}));
    try {
        const  params  = e.payload;
        const url = `user/${params.id}`
        const response = yield call(
            apiRequest.put,
            url,
            params
        );

        // Extraigo todos los datos
        const { result } = response;
        yield put(usersActions.update({result}));
    } catch (err) {
        yield put(usersActions.errorUpdate({error:true, message:err.message}));
    } finally {
        yield put(usersActions.conexionUpdate({connection:false}));
    }
}

export function* watchFetchSesion() {
    yield takeLatest(usersActionsSaga.getAllUsers.type,  getAllFetch);
    yield takeLatest(usersActionsSaga.getByIdUsers.type,  getByIdFetch);
    yield takeLatest(usersActionsSaga.createUsers.type,  createFetch);
    yield takeLatest(usersActionsSaga.updateUsers.type,  updateFetch);
}

export default function* rootSaga() {
    yield spawn(watchFetchSesion);
}


const getAllUsers = createAction('userSaga/getAllUsers');
const getByIdUsers = createAction('userSaga/getByIdUsers');
const createUsers = createAction('userSaga/createUsers');
const updateUsers = createAction('userSaga/updateUsers');

export const usersActionsSaga = {
    getAllUsers,
    getByIdUsers,
    createUsers,
    updateUsers
};
